
export class SolicitudCpeProductosViewModel {
    public Id: number;
    public IdEstadoSolicitudCpe: number;
    public Codigo: string;
    public IdEstadoSolicitudCpeDescripcion: string;
    public TwProductoCertificadoPrevioExCollection: TwProductoCertificadoPrevioExViewModel[];
}

export class TwProductoCertificadoPrevioExViewModel {
    public Id: number;
    public IdCertPrevioEx: number;
    public CodigoTaric: string;
    public CodigoEppo: string;
    public IdEspecie: number;
    public IdBotanicaDescripcion: string;
    public NombreComun: string;
    public IdGrupo: number;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public Peso: number;
    public Volumen: number;
    public Unidades: number;
    public IdEstadoSolicitudCpeDescripcion: string;
    public Grupo: string;
    public IdEstadoSolicitudCpe: number;
    public Codigo: string;
    public IdUnidadMedidaPeso: number;
    public UnidadMedidaPeso: string;
}






